import { useT } from "../i18n/hooks.ts";
import { Dialog } from "./Dialog.tsx";
import { DialogActions } from "./DialogActions.tsx";

/** Single OK button, no confirm/cancel choice — unlike ConfirmDialog.tsx. */
export function AlertDialog({
  title,
  message,
  onClose,
}: {
  title: string;
  message: string;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <Dialog title={title} onClose={onClose}>
      <p>{message}</p>
      <DialogActions primary={{ label: t("common.ok"), onClick: onClose }} />
    </Dialog>
  );
}
